import { createFileRoute, redirect } from "@tanstack/react-router";
import LeaDataViewPage from "@/pages/LeaDataViewPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/lea-data-view"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("ADMIN")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: LeaDataViewPage,
});
